
const digest = 'd46b157a624356c5d3278134c0182965d9b2331539997b92cf6c21311d1be92b';
const classes = {"wrapper":"_wrapper_1d1px_1","title":"_title_1d1px_7","value":"_value_1d1px_10","button":"_button_1d1px_13"};
const css = `._wrapper_1d1px_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_1d1px_1 ._title_1d1px_7 {
  font-weight: 500;
}
._wrapper_1d1px_1 ._value_1d1px_10 {
  font-weight: 500;
}
._wrapper_1d1px_1 ._button_1d1px_13 {
  width: fit-content;
  min-width: 100px;
  margin-top: 15px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  